"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectionList = void 0;
var react_1 = require("react");
/**
 * Simple helper for collections
 */
function useSelectionList(initialList) {
    if (initialList === void 0) { initialList = []; }
    var _a = (0, react_1.useState)(initialList), list = _a[0], setList = _a[1];
    var removeSelection = (0, react_1.useCallback)(function (value) {
        var newList = list.filter(function (v) { return v !== value; });
        setList(newList);
    }, [list]);
    var addSelection = (0, react_1.useCallback)(function (value) {
        setList(__spreadArray(__spreadArray([], list, true), [value], false));
    }, [list]);
    var has = (0, react_1.useCallback)(function (id) {
        return list.includes(id);
    }, [list]);
    var toggleItem = (0, react_1.useCallback)(function (value) {
        if (has(value)) {
            removeSelection(value);
            return;
        }
        addSelection(value);
    }, [has, addSelection, removeSelection]);
    var addAll = (0, react_1.useCallback)(function (values) {
        var valuesToAdd = values.filter(function (v) { return !has(v); });
        setList(__spreadArray(__spreadArray([], list, true), valuesToAdd, true));
    }, [has, list,]);
    var removeAll = (0, react_1.useCallback)(function (values) {
        if (!values) {
            setList([]);
            return;
        }
        setList(list.filter(function (value) { return !values.includes(value); }));
    }, [list]);
    var clear = (0, react_1.useCallback)(function () {
        setList([]);
    }, []);
    return {
        list: list,
        add: addSelection,
        remove: removeSelection,
        has: has,
        toggleItem: toggleItem,
        removeAll: removeAll,
        addAll: addAll,
        setList: setList,
        clear: clear
    };
}
exports.useSelectionList = useSelectionList;
